/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import FOTable from '../../../components/foTable/FOTable';
import TableFilter from '../../../components/foTable/foTableFilter/TableFilter';
import { useScreenSize } from '../../../shared/theming/useScreenSize';
import { useTheming } from '../../../shared/theming/useTheming';
import useRemoveUserFromOrg from '../../../redux/features/user/remove/useRemoveUserFromOrg';
import RemoveUserDialog from '../../../components/user/removeUserDialog';
import { computeCombinedCellEntries } from './UserTable.helper';
import useUserTable from './useUserTable';

export default function UserTable({ currentOrganization }) {
  const { isMediumOrBigger } = useScreenSize();
  const theming = useTheming();

  const {
    tableConfiguration,
    rows,
    columns,
    data,
    totalCount,
    loading,
    pageNo,
    pageSize,
    filter,
    setPageNo,
    getUsers,
    setPageSize,
    setFilter,
    getSortOrderForColumn,
    onSortOrderClick,
    handleSelectAll,
    handleSelectRow,
    isAllSelected,
    isRowSelected,
  } = useUserTable(theming);

  const { removeDialog, userId, onToggleRemoveDialog, onRemoveUserConfirm } = useRemoveUserFromOrg(
    currentOrganization?.id,
    getUsers,
  );

  return (
    <>
      <section
        data-testId="users-table"
        aria-labelledby="users-table"
        aria-describedby="users-table"
        style={{ overflowX: 'auto' }}
      >
        <TableFilter
          isLargeScreen={isMediumOrBigger}
          filter={filter}
          setFilter={setFilter}
          updatePage={setPageNo}
          isAddressBookPage={false}
          columnsConfiguration={tableConfiguration?.columns}
        />
        <FOTable
          columns={columns}
          rows={rows}
          data={data}
          totalCount={totalCount}
          loading={loading}
          page={pageNo}
          filter={filter}
          pageSize={pageSize}
          tableConfiguration={tableConfiguration}
          updatePageAction={setPageNo}
          updatePageSizeAction={setPageSize}
          isAllSelected={isAllSelected}
          handleSelectAll={handleSelectAll}
          getSortOrderForColumn={getSortOrderForColumn}
          onClickColumn={onSortOrderClick}
          isRowSelected={isRowSelected}
          handleSelectRow={handleSelectRow}
          setFilter={setFilter}
          computeCombinedCellEntries={computeCombinedCellEntries}
          emptyTableSuggestion="It looks like you have no users"
          emptyTableWarningMessage="Invite"
        />
      </section>

      {removeDialog.open && (
        <RemoveUserDialog
          userId={userId}
          dialog={removeDialog}
          toggleDialog={onToggleRemoveDialog}
          onSubmit={onRemoveUserConfirm}
        />
      )}
    </>
  );
}
